import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button, DropdownToggle, DropdownMenu, DropdownItem , UncontrolledDropdown,
  Badge
} from "reactstrap";
import {
  Link
} from "react-router-dom";

import ReactTable from "react-table";
import VirtualMachineTypeService from '../../services/api/VirtualMachineType'; 
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import { Scrollbars } from 'react-custom-scrollbars';
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Pagination from "../../assets/js/Pagination";
import { cloudTypeLogo } from "settings/shared/commonMethod";
import ProvisionerService from '../../services/api/Provisioner'; 
import { vmServiceName } from '../../settings/shared/constants';

class machinetype extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns:[],
      vmTypeDTOS:[],
      instanceTypedetails:[],
      provisionerNamelist:[],
    swidth: window.innerWidth,
    sheight: window.innerHeight,
    tenantRole:""
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this.state.columns = [
      {
      Header: 'Id',
      accessor: 'Id',
      sortable: true,
      show: false
    }, 
    {
    Header: 'Name',
    accessor: 'name',
    maxWidth: 200,
    sortable: true,
     }, 
    {
    Header: 'Instance Type',
    accessor: 'instanceType',
    maxWidth: 200,
  },
  {
    Header: 'Status',
    accessor: 'serviceStatus',
    maxWidth: 200,
  },
  {
    Header: 'Description',
    accessor: 'description',
    maxWidth: 200,
  },
  {
    Header: 'Cloud Type',
    accessor: 'cloudType',
    maxWidth: 150,
  },
  {
    Header: 'Location',
    accessor: 'location',
    maxWidth: 200,
  },
  {
    Header: 'Provisioner',
    accessor: 'provisionerName',
    maxWidth: 200,
  },
 
  {
    Header: 'Actions',
    accessor: 'Actions',
    maxWidth: 200,

  }

];
  }
  componentDidMount() {
    this.setState({
      tenantRole: localStorage.getItem("role")
      })
    this.GetAllVMType();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }

  EditVM = (data) =>{
    this.props.history.push({
      pathname: '/cloud/newmachinetype',
      state: { EditData: data,mode:"editMachineType" }
    })
  }


  DeleteVMConfirm = (id,name) =>{
    confirmAlert({
      title: 'Remove Machine Type',
      message: 'Are you sure to remove this Machine Type -' + name + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.DeleteVM(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }
   DeleteVM = (id) =>{
  if(id !== ""){
    VirtualMachineTypeService.deleteVMType(id).then((response) => {
    if (response.status === 'SUCCESS') {
      toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Instance Type Deleted Successfully!</b></i>); 
      // toast.success("Instance Type Deleted Successfully!");
      this.GetAllVMType();
    } else {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
    }
   }); 

}
}

DisableVM_Confirmation = (id, e, name) => {
  confirmAlert({
    title: <h5>Disable Virtual Machine Type</h5>,
    message: <div><span>
      Are you sure to Disable this Virtual Machine Type? -  <b>{name}</b>
    </span><br />
    </div>,
    buttons: [
      {
        label: 'Yes',
        onClick: () => this.Changestatus('DISABLED',id,name)
      },
      {
        label: 'No',
        onClick: () => console.log('no')
      }
    ]
  });
}
EnableVM_Confirmation = (id, e, name) => {
  confirmAlert({
    title: <h5>Enable Virtual Machine Type</h5>,
    message: <div><span>
      Are you sure to Enable this Virtual Machine Type? -  <b>{name}</b>
    </span><br />
    </div>,
    buttons: [
      {
        label: 'Yes',
        onClick: () => this.Changestatus('ENABLED',id,name)
      },
      {
        label: 'No',
        onClick: () => console.log('no')
      }
    ]
  });
}

Changestatus = (status,id,name) =>{
  VirtualMachineTypeService.updateMachineTypeStatus(status,id)
  .then((response) => {
    if (response.status === 'SUCCESS') {
      let msg = <div>{name} {status} Successfully</div>
      toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">{msg}</b></i>); 
      this.GetAllVMType();
      //this.props.history.push('/cloud/machinetype/');
    } else {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
    }
  }).catch((error) => {
    this.setState({ loading:false });
  })
  
}

  GetAllVMType = () =>{
  this.setState({
    loading:true
  })
    VirtualMachineTypeService.getVMTypes()
  .then((response) => {
    if (response.status === 'SUCCESS') {
      let vmtypeData = response.virtualMachineTypeDTOs;
      this.renderData(vmtypeData); 
      this.setState({
        vmTypeDTOS:vmtypeData,
        loading: false,
      });
      } else {
      this.setState({ loading: false}); 
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
    }
  }).catch((error) => {
    this.setState({ loading:false });
  }) 
}

 renderData(instanceTypedetails){
  let datas = []; 
  let provisionerName = [];
  instanceTypedetails.map((item, index) => {
    ProvisionerService.getProvisionerByService(vmServiceName)
    .then((response) => {
      this.setState({
        provisionerRecords:response.provisionerDTOPage.content,
        loading: false,
      })
      provisionerName = this.state.provisionerRecords.map((itemm,index) => {
        if(itemm.id === item.provisionerId)
        {
          this.setState({
            provisionerNamelist:itemm.name,
            loading: false,
          })
          provisionerName = itemm.name;
        }
    })
    })

   datas.push({
     
     Id: item.id, 
     name: <div className="namedisplay"> <span title={item.name} className="overflowStyle">{item.name}</span></div>,
     instanceType:item.instanceType,
     serviceStatus: <div> {item.serviceStatus === "ENABLED" &&
      <Badge color="" className="badge-dot"><i className="bg-success" />AVAILABLE</Badge>
    }
    {item.serviceStatus === "DISABLED" &&
      <Badge color="" className="badge-dot"><i className="bg-darkgray" />NOT AVAILABLE</Badge>
    }</div>,
     description:<div className="namedisplay"><span title={item.description} className="overflowStyle">{item.description} </span></div>,
     cloudType:<div> {<img src={cloudTypeLogo(item.cloudType)} style={{ width: '30px', height: '30px' }}></img>
    }</div> ,
    location:item.location,
    provisionerName:<div className="namedisplay">{provisionerName}</div>,
    Actions: ((item.platformDefault === true && this.state.tenantRole === "PLATFORM_ADMIN")
       || (item.platformDefault === false && this.state.tenantRole !== "PLATFORM_ADMIN")) && <div className="row">
         <span><i onClick={e => this.EditVM(item)} className="fa fa-edit text-info pointerclass" />
           <i onClick={e => this.DeleteVMConfirm(item.id, item.name)} className="fas fa-trash-alt text-red mr-2 icon-disable-vm" /> </span> &nbsp;
         <UncontrolledDropdown direction={(index > 6 ? "up" : "down")}>
           <DropdownToggle
             tag="span"
             onClick={e => e.preventDefault()}
             className="icon-disabeltoggle-vm"
           >
             <i className="fas fa-ellipsis-v" />
           </DropdownToggle>
           <DropdownMenu
             persist right
             className="dropdown-menu-arrow"
           >
             <DropdownItem
               onClick={e => {
                 e.preventDefault()
               }}
             >
               <span>
                 {(item.serviceStatus === "ENABLED")
                   ?
                   <span className="actionicon" id={'action' + index} onClick={e => { this.DisableVM_Confirmation(item.id, e, item.name) }}><i className="fas fa-toggle-off mr-2 df-text-danger"></i> &nbsp;Disable
                   </span>
                   :
                   <span className="actionicon" id={'action' + index} onClick={e => { this.EnableVM_Confirmation(item.id, e, item.name) }}><i className="fas fa-toggle-on mr-2 df-text-success"></i> &nbsp;Enable
                   </span>
                 }                   </span>
             </DropdownItem>
           </DropdownMenu>
         </UncontrolledDropdown>
       </div>,
  
  
  })
  });

   this.setState({
      instanceTypedetails:datas,
   });

}
 

  
  render() {
    return (
  
      <>
        <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
            <Row>
            <div className=" col">
              <Card>
                <CardHeader>
                <Row className="align-items-center">
                <div className="col">
                  <CardTitle tag="h5">Machine Type</CardTitle>
                 </div>
                 <div className="col text-right">
                      <span> <i className="fas fa-sync-alt mr-3 pointerclass" onClick={e =>this.GetAllVMType()}/></span>
                       <Link to={{ 
                        pathname: '/cloud/newmachinetype',
                        state: { mode:"addnew" }
                      }}> 
                         <Button
                        color="primary"
                        href=""
                        size="sm"
                      >
                      Create
                      </Button>
                      </Link>
                    </div>
                </Row>
                  
                </CardHeader>
                <CardBody >
                <div className="carcontent">
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>
                <ReactTable
         data={ this.state.instanceTypedetails}
         columns={ this.state.columns }
         defaultPageSize={10}
         PaginationComponent={Pagination}
         showPaginationBottom={true}
         className="-striped -highlight Providerstable"
          />
                       </Scrollbars>

          </div>
              </CardBody>
              </Card>
           </div>
           </Row>

            </Col>
          </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default machinetype;

